export function getBaseURL() {
    // set back-end endpoints
    let baseurl = 'http://localhost:8081'
    if(process.env.NODE_ENV === 'production') {
        console.log('production')
        baseurl = ''
    }else {
        console.log('development')
    }
    return baseurl
}